import React from 'react';
import {
  TextField,
  Container,
  Grid,
  Typography,
  Paper,
  InputAdornment,
  IconButton,
  Link,
} from '@mui/material';
import { makeStyles } from '@mui/styles';
import { CopyIcon } from '../../../../icons/CopyIcon';
import { ErrorIcon } from '../../../../icons/ErrorIcon';
import { SupportedList } from './SupportedList';

const useStyles = makeStyles({
  paper: {
    padding: '1.5em',
    borderRadius: '8px',
    width: '300px',
  },
  paperContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  copyButton: {
    borderLeft: 'solid 1px #E1E3EA',
    maxHeight: '2.5em',
    display: 'flex',
  },
  errorIcon: {
    position: 'absolute',
    right: 'calc(100% + 18px)',
  },
  caption: {
    marginTop: '1.3em',
  },
});

export function UnsupportedBrowser() {
  const classes = useStyles();

  const appURL = window.location.href;

  const copyAppLink = () => {
    navigator.clipboard.writeText(appURL);
  };

  return (
    <>
      <Container style={{ minHeight: '250px' }}>
        <Grid container alignItems="center" justifyContent="space-between">
          <Grid item xs={5}>
            <Typography variant="h5" gutterBottom style={{ position: 'relative' }}>
              <div className={classes.errorIcon}>
                <ErrorIcon />
              </div>{' '}
              New browser needed
            </Typography>
            <Typography variant="body1" gutterBottom>
              Oh no, your browser isn't supported! Download and install a new one from the list,
              copy this url and paste it into your new browser to restart the test.
            </Typography>
            <TextField
              fullWidth={true}
              id="read-only-app-link"
              defaultValue={appURL}
              variant="outlined"
              size="small"
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <div className={classes.copyButton}>
                      <IconButton edge="end" onClick={copyAppLink}>
                        <CopyIcon />
                      </IconButton>
                    </div>
                  </InputAdornment>
                ),
                readOnly: true,
              }}
            />
          </Grid>
          ​
          <Grid item xs={5} className={classes.paperContainer}>
            <Paper className={classes.paper}>
              <SupportedList />
            </Paper>
            <Typography variant="caption" align="center" className={classes.caption}>
              We support the most recent and the two previous versions. Please{' '}
              <Link
                color="inherit"
                underline="always"
                target="_blank"
                rel="noopener"
                href="https://www.twilio.com/docs/video/javascript#supported-browsers"
              >
                visit our docs
              </Link>{' '}
              for more details.
            </Typography>
          </Grid>
        </Grid>
      </Container>
    </>
  );
}
